import * as React from "react";

const CheckCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
            viewBox="0 0 32 32" fill="none">
            <rect x="-0.000244141" width="32" height="32" rx="16" fill="#EAEBEB"/>
            <g clip-path="url(#clip0_13867_94341)">
                <path d="M22.9998 10.41L21.5898 9L15.9998 14.59L10.4098 9L8.99976 10.41L14.5898 16L8.99976 21.59L10.4098 23L15.9998 17.41L21.5898 23L22.9998 21.59L17.4098 16L22.9998 10.41Z" fill="#0C0C0C"/>
            </g>
            <defs>
                <clipPath id="clip0_13867_94341">
                    <rect width="24" height="24" fill="white" transform="translate(3.99976 4)"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(CheckCircle);